module.exports = __webpack_public_path__ + "media/images/royalslider/b-af0fbc2f0fe70a7855a75174c155de6d.jpg";